import { runInAction } from 'mobx';
import Action from '../../../../decorators/Action';
import Observable from '../../../../decorators/Observable';
import StoreFieldInSession from '../../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../../models/AbstractSessionModel';
import Api from '../../../../services/Api';
import Computed from '../../../../decorators/Computed';
import IPicture from './IPicture';

/**
 * This model will store the uploaded pictures in step preview.
 */
class PictureModel extends AbstractSessionModel {
  /** Store the if of the picture that is currently opened in the picture edit modal. */
  @Observable()
  public pictureEditModalOpened = null;

  /**
   * Selected picture inside of the picture edit modal.
   */
  @Observable()
  public selectedPicture: IPicture = null;

  @Observable()
  @StoreFieldInSession()
  public uploadedPictures: {
    ObjectURL: string;
    PresignedUrl: string;
  }[] = [];

  @Observable()
  @StoreFieldInSession()
  public paginatedCursor = 8;

  @Observable()
  public stockImages: {
    media_id: string;
    thumbnailUrl: string;
  }[] = [];

  @Observable()
  public loadingImages = false;

  constructor() {
    super();

    super.initFields();
  }

  @Action()
  public addPicture(picture: { ObjectURL: string; PresignedUrl: string }) {
    this.uploadedPictures.push(picture);
  }

  @Action()
  public openPictureEditModal(pictureId: number) {
    this.pictureEditModalOpened = pictureId;
  }

  @Action()
  public closePictureEditModal() {
    this.pictureEditModalOpened = null;
  }

  @Action()
  public selectPicture(picture: IPicture) {
    this.selectedPicture = picture;
  }

  @Action()
  public reset() {
    this.paginatedCursor = 8;
    this.stockImages = [];
    this.loadingImages = false;
    this.selectedPicture = null;
  }

  @Action()
  public async searchStockImages(query: string) {
    this.loadingImages = true;
    this.stockImages = [];

    const stockImages = await Api.searchStockImages(query);

    runInAction(() => {
      this.stockImages = stockImages.data;
      this.paginatedCursor = 8;
      this.loadingImages = false;
    });
  }

  @Computed()
  get paginatedStockImages() {
    return this.stockImages.slice(0, this.paginatedCursor);
  }

  @Action()
  public loadMoreStockImages() {
    this.paginatedCursor += 8;
  }

  public getSessionKey() {
    return 'PictureModel';
  }
}

export default new PictureModel();
